import constants from '../constants';

const { ApiConstants } = constants;
const {
  submitApi,
  marketingUnsubscribe,
} = ApiConstants;

export { submitApi, marketingUnsubscribe };
